import React from 'react';
import { useTranslation } from 'react-i18next';

/** "Skip to content" (IS 5568): the first thing keyboard users reach; visible only when focused. */
export default function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:start-2 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-[10px] focus:bg-ink focus:text-paper focus:text-sm focus:font-medium"
    >
      {t('a11y.skipToContent')}
    </a>
  );
}
